<template>
  <div class="main">
    <popupLayout>
      <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.showAddInterviewPopupControl(false);">×</button>
      <div class="bootbox-body">
        <h4 class="col-md-12">新增晤談記錄</h4>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2 column-required">學號</label>
            <div class="col-md-10">
              <input type="text" name="account" v-model="account" class="form-control" v-validate="'required'"/>
              <span class="text-danger" v-show="errors.has('account')">{{ errors.first('account') }}</span>
            </div>
          </div>
        </div>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2">學制</label>
            <div class="col-md-10">
              <input type="text" name="deptSsymStr" v-model="deptSsymStr" class="form-control" readonly/>
            </div>
          </div>
        </div>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2">系科年級</label>
            <div class="col-md-10">
              <input type="text" name="deptCodeStr" v-model="deptCodeStr" class="form-control" readonly/>
            </div>
          </div>
        </div>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2">姓名</label>
            <div class="col-md-10">
              <input type="text" name="name" v-model="name" class="form-control" readonly/>
            </div>
          </div>
        </div>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2">宿舍床位</label>
            <div class="col-md-10">
              <input type="text" name="bed" v-model="bed" class="form-control" readonly/>
            </div>
          </div>
        </div>
        <div class="row form-group mb-lg">
          <div class="col-md-12">
            <label class="col-md-2 column-required">晤談記錄</label>
            <div class="col-md-10">
              <textarea class="form-control" name="tutorRecord" v-model="interviewContent" rows="5" maxlength="400" v-validate="'required|max:400'"></textarea>
              <span class="text-danger" v-show="errors.has('tutorRecord')">{{ errors.first('tutorRecord') }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-offset-4 col-md-4">
            <div class=" col-md-offset-3 col-md-6">
              <a class="btn btn-danger btn-block" @click="saveInterview">送出</a>
            </div>
          </div>
        </div>
      </div>
    </popupLayout>
  </div>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
  components:{
    popupLayout
  },
  data(){
    return {
      account: "",
      deptSsymStr: "",
      deptCodeStr: "",
      name: "",
      bed: "",
      interviewContent: "",
      isValidAccount: false
    }
  },
  methods:{
    closePopup() {
      this.$parent.showAddInterviewPopupControl(false);
    },
    saveInterview(){
      let _this = this;
      if(!this.isValidAccount) {
        bootbox.alert("請確認學號是否正確");
        return;
      }
      this.$validator.validateAll().then(result => {
        if(result){
          const api = "/api/Violate/saveInterview";
          this.$axios.post(api, JSON.stringify({
            account:this.account,
            interviewContent:this.interviewContent
          })).then(resp => {
            bootbox.alert(resp.data.msg, function(){
              if(resp.data.status == "success"){
                _this.closePopup();
              }
            });
          });
        }else{
          bootbox.alert("請確認必填欄位是否有填寫");
        }
      });
    },
    containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
    clearDormitoryInfoAndInvalid() {
      this.deptSsymStr = "";
      this.deptCodeStr = "";
      this.name = "";
      this.bed = "";
      this.isValidAccount = false;
    }
  },
  watch: {
    "account": function(){
      const account = this.account;
      if(account.length == 9 && this.containsOnlyNumbers(account)) {
        const api = "/api/Violate/violateRecordTotalGrid";
        this.$axios.post(api, JSON.stringify({
          page:1,
          pageSize:1,
          model: {
            account: this.account
          }
        })).then(resp =>{
          if(resp.data.data.total) {
            this.isValidAccount = true;
            this.deptSsymStr = resp.data.data.rows[0].deptSsymStr;
            this.deptCodeStr = `${resp.data.data.rows[0].deptCodeStr}-${resp.data.data.rows[0].drade}年${resp.data.data.rows[0].dradeClass}`;
            this.name = resp.data.data.rows[0].name;
            this.bed = `${resp.data.data.rows[0].bedFloor}${resp.data.data.rows[0].bedRoom}-${resp.data.data.rows[0].bed}`
          } else {
            this.clearDormitoryInfoAndInvalid();
          }
        });
      } else {
        this.clearDormitoryInfoAndInvalid();
      }
    }
  }
}
</script>
